import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertService, AuthorizeService, FormValidationService, ValidationError, FormValidator, ErrorHandlingService } from 'core-lib';
import { AdminDetailsViewModel } from './user-account-details.vm';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SetPasswordModalComponent } from '../modals/set-password-modal/set-password-modal.component';
import { YesCancelModalComponent } from '../modals/yes-cancel-modal/yes-cancel-modal.component';

import { UserAccountService, AdminDetailsModel, AdminDetails } from '../services/user-account.service';
import { PermitDetailsModel, PermitService } from '../services/permit.service';


@Component({
  selector: 'cli-user-account-details',
  templateUrl: './user-account-details.component.html',
  styleUrls: ['./user-account-details.component.scss']
})
export class UserAccountDetailsComponent implements OnInit {

  @ViewChild('setPasswordModal')
  public modal: SetPasswordModalComponent;


  @ViewChild('userDelete')
  public confirmModal: YesCancelModalComponent;

  public vm = new AdminDetailsViewModel();
  public validator: FormValidator;

  constructor(private permitSvc: PermitService,
    private formValidationSvc: FormValidationService,
    private useracctSvc: UserAccountService,
    private errorHandlingSvc: ErrorHandlingService,
    private alertSvc: AlertService,
    private router: Router,
    private route: ActivatedRoute) {

    this.vm.isLoading = true;
    this.vm.isOpening = true;

    this.validator = this.formValidationSvc.getFormValidator(this.vm);

    let paramId: string = this.route.snapshot.paramMap.get('id');
    let parsed = parseInt(paramId, 10);
    let id = isNaN(parsed) ? 0 : parsed;
    this.vm.userId = id;
    if (id === 0) {
      this.vm.header = 'New Operator';
      this.vm.isNew = true;
    }
    else {
      this.vm.header = 'Edit Operator';
      this.vm.isNew = false;
    }

  }

  ngOnInit() {
    this.permitSvc.getDetails().toPromise().then((permitdata: PermitDetailsModel) => {
      if (permitdata != null) {
        this.vm.permitId = permitdata.permitDetails.permitId;
        this.vm.permitNo = permitdata.permitDetails.permitNo;
        this.vm.businessName = permitdata.permitDetails.clientName;

        if (this.vm.userId !== 0) {
          this.useracctSvc.getDetails(this.vm.permitNo, this.vm.userId).toPromise()
            .then((data: AdminDetailsModel) => {
              if (data)
                this.mapModel(this.vm, data);
            }, (e) => {
              this.errorHandlingSvc.processHttpError(e);
              this.router.navigate([`app/user-accounts`]);
              this.vm.isLoading = false;
              this.vm.isOpening = false;
            })
            .finally(() => {
              this.vm.isLoading = false;
              this.vm.isOpening = false;
            });
        }
        else {
          this.vm.userId = 0;
          this.vm.isActive = true;
          this.vm.isLoading = false;
          this.vm.isOpening = false;
        }
      }
    },
      (e) => {
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });

  }

  mapModel(vm: AdminDetailsViewModel, data: AdminDetailsModel) {

    let details = data.adminDetails;

    vm.userId = details.userId;
    vm.userName = details.userName;
    vm.firstName = details.firstName;
    vm.lastName = details.lastName;
    vm.email = details.email;
    vm.isActive = details.isActive;

  }

  validate(vm: AdminDetailsViewModel): boolean {
    vm.errors = [];

    this.validator.validateRequired('userName', 'Username');


    this.validator.validateCustom('userName', 'Phone must be a valid phone no. (like 0412345678)', () => {
      const phone = this.vm.userName;
      return !phone || !/^04\d{8}$/.test(phone);
    });

    this.validator.validateMaxLength('userName', 'Username', 100);

    this.validator.validateRequired('firstName', 'First Name');
    this.validator.validateMaxLength('firstName', 'First Name', 100);

    this.validator.validateRequired('lastName', 'Last Name');
    this.validator.validateMaxLength('lastName', 'Last Name', 100);

    this.validator.validateRequired('email', 'Email');
    this.validator.validateEmail('email', 'Email');
    this.validator.validateMaxLength('email', 'Email', 100);

    if (this.vm.userId === 0) {

      this.validator.validateMinLength('password', 'Password', 6);
      this.validator.validateMinLength('confirmPassword', 'Password', 6);

      this.validator.validateRequired('password', 'Password');
      this.validator.validateRequired('confirmPassword', 'Confirm Password');
      this.validator.validateCustom('password', 'Passwords don\'t match',
        () => { return this.vm.password !== this.vm.confirmPassword; });
    }

    return vm.errors.length === 0;

  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public save() {
    if (!this.validate(this.vm)) { return; }

    this.vm.isLoading = true;

    let createOrUpdateAdmin$: Promise<AdminDetailsModel>;

    let data = new AdminDetails();
    data.userId = this.vm.userId;
    data.userName = this.vm.userName;
    data.firstName = this.vm.firstName;
    data.lastName = this.vm.lastName;
    data.email = this.vm.email;
    data.isActive = this.vm.isActive;
    data.permitId = this.vm.permitId;


    if (this.vm.userId === 0) {
      data.password = this.vm.password;
      createOrUpdateAdmin$ = this.useracctSvc.createAdmin(data).toPromise();
    } else {
      createOrUpdateAdmin$ = this.useracctSvc.updateAdmin(data).toPromise();
    }


    createOrUpdateAdmin$.then((model: AdminDetailsModel) => {

      if (this.vm.userId === 0) {
        this.alertSvc.success(environment.TOASTR_HEADER, 'The record was successfully created ', 2000);
      }
      else {
        this.alertSvc.success(environment.TOASTR_HEADER, 'The record was successfully updated ', 2000);
      }

      if (this.vm.isNew) {
        this.vm.isNew = false;
        this.vm.header = 'Edit Admin';
        this.vm.userId = model.adminDetails.userId;
        this.router.navigate(['app/user-accounts']);
      }

    }, (e) => {

      this.errorHandlingSvc.processHttpError(e);


    }).finally(() => { this.vm.isLoading = false; });

  }

  public cancel() {
    this.router.navigate(['app/user-accounts']);
  }

  public setPassword() {
    this.vm.newPassword = '';
    this.modal.openModal().subscribe((n: string) => {
      if (n === 'Yes') {

        let data = new AdminDetails();
        data.userId = this.vm.userId;
        data.password = this.modal.password;
        data.permitId = this.vm.permitId;

        this.vm.isLoading = true;

        this.useracctSvc.updateAdmin(data).toPromise().then(() => {
          this.alertSvc.success(environment.TOASTR_HEADER, 'Password successfully updated', 2000, false);
        }, (e) => {
          this.errorHandlingSvc.processHttpError(e);
        }).finally(() => { this.vm.isLoading = false; });
      }
    },
      (e: any) => { });
  }

  public delete() {

    this.confirmModal.message = 'Are you sure you want to delete this user account? WARNING: You cannot undo this action. Continue?';
    this.confirmModal.openModal().toPromise().then((result: string) => {

      if (result === 'Yes') {

        this.vm.isLoading = true;

        this.useracctSvc.deleteAdmin(this.vm.userId).toPromise().then(() => {
          this.router.navigate(['app/user-accounts']);
        },
          (e) => { this.errorHandlingSvc.processHttpError(e); })
          .finally(() => { this.vm.isLoading = false; });
      }

    });

  }
}

